// Thread Library - Comprehensive UNC, UNF, and Metric thread data
// Sources: ASME B1.1 (Unified), ISO 261/262 (Metric)

export const threadTypes = {
  imperial: {
    label: 'Imperial (Unified National)',
    series: {
      UNC: { label: 'UNC - Coarse', description: 'General purpose, fast assembly' },
      UNF: { label: 'UNF - Fine', description: 'Higher strength, vibration resistance' },
      UNEF: { label: 'UNEF - Extra Fine', description: 'Thin wall, instrumentation' },
    }
  },
  metric: {
    label: 'Metric (ISO)',
    series: {
      coarse: { label: 'Coarse', description: 'Standard, general purpose' },
      fine: { label: 'Fine', description: 'Higher strength, vibration resistance' },
    }
  }
};

// Imperial UNC threads - { designation, tpi, majorDia, pitchDia, minorDiaMale, minorDiaFemale, pitch }
export const uncThreads = [
  { designation: '#1-64',     tpi: 64, majorDia: 0.0730, pitchDia: 0.0629, minorDiaMale: 0.0544, pitch: 0.01563 },
  { designation: '#2-56',     tpi: 56, majorDia: 0.0860, pitchDia: 0.0744, minorDiaMale: 0.0648, pitch: 0.01786 },
  { designation: '#3-48',     tpi: 48, majorDia: 0.0990, pitchDia: 0.0855, minorDiaMale: 0.0741, pitch: 0.02083 },
  { designation: '#4-40',     tpi: 40, majorDia: 0.1120, pitchDia: 0.0958, minorDiaMale: 0.0822, pitch: 0.02500 },
  { designation: '#5-40',     tpi: 40, majorDia: 0.1250, pitchDia: 0.1088, minorDiaMale: 0.0952, pitch: 0.02500 },
  { designation: '#6-32',     tpi: 32, majorDia: 0.1380, pitchDia: 0.1177, minorDiaMale: 0.1007, pitch: 0.03125 },
  { designation: '#8-32',     tpi: 32, majorDia: 0.1640, pitchDia: 0.1437, minorDiaMale: 0.1267, pitch: 0.03125 },
  { designation: '#10-24',    tpi: 24, majorDia: 0.1900, pitchDia: 0.1629, minorDiaMale: 0.1404, pitch: 0.04167 },
  { designation: '#12-24',    tpi: 24, majorDia: 0.2160, pitchDia: 0.1957, minorDiaMale: 0.1788, pitch: 0.04167 },
  { designation: '1/4-20',    tpi: 20, majorDia: 0.2500, pitchDia: 0.2175, minorDiaMale: 0.1905, pitch: 0.05000 },
  { designation: '5/16-18',   tpi: 18, majorDia: 0.3125, pitchDia: 0.2764, minorDiaMale: 0.2464, pitch: 0.05556 },
  { designation: '3/8-16',    tpi: 16, majorDia: 0.3750, pitchDia: 0.3344, minorDiaMale: 0.3005, pitch: 0.06250 },
  { designation: '7/16-14',   tpi: 14, majorDia: 0.4375, pitchDia: 0.3911, minorDiaMale: 0.3525, pitch: 0.07143 },
  { designation: '1/2-13',    tpi: 13, majorDia: 0.5000, pitchDia: 0.4500, minorDiaMale: 0.4084, pitch: 0.07692 },
  { designation: '9/16-12',   tpi: 12, majorDia: 0.5625, pitchDia: 0.5084, minorDiaMale: 0.4633, pitch: 0.08333 },
  { designation: '5/8-11',    tpi: 11, majorDia: 0.6250, pitchDia: 0.5660, minorDiaMale: 0.5168, pitch: 0.09091 },
  { designation: '3/4-10',    tpi: 10, majorDia: 0.7500, pitchDia: 0.6850, minorDiaMale: 0.6309, pitch: 0.10000 },
  { designation: '7/8-9',     tpi: 9,  majorDia: 0.8750, pitchDia: 0.8028, minorDiaMale: 0.7427, pitch: 0.11111 },
  { designation: '1-8',       tpi: 8,  majorDia: 1.0000, pitchDia: 0.9188, minorDiaMale: 0.8512, pitch: 0.12500 },
  { designation: '1-1/8-7',   tpi: 7,  majorDia: 1.1250, pitchDia: 1.0322, minorDiaMale: 0.9549, pitch: 0.14286 },
  { designation: '1-1/4-7',   tpi: 7,  majorDia: 1.2500, pitchDia: 1.1572, minorDiaMale: 1.0799, pitch: 0.14286 },
  { designation: '1-3/8-6',   tpi: 6,  majorDia: 1.3750, pitchDia: 1.2667, minorDiaMale: 1.1766, pitch: 0.16667 },
  { designation: '1-1/2-6',   tpi: 6,  majorDia: 1.5000, pitchDia: 1.3917, minorDiaMale: 1.3016, pitch: 0.16667 },
  { designation: '1-3/4-5',   tpi: 5,  majorDia: 1.7500, pitchDia: 1.6201, minorDiaMale: 1.5119, pitch: 0.20000 },
  { designation: '2-4.5',     tpi: 4.5,majorDia: 2.0000, pitchDia: 1.8557, minorDiaMale: 1.7353, pitch: 0.22222 },
  { designation: '2-1/4-4.5', tpi: 4.5,majorDia: 2.2500, pitchDia: 2.1057, minorDiaMale: 1.9853, pitch: 0.22222 },
  { designation: '2-1/2-4',   tpi: 4,  majorDia: 2.5000, pitchDia: 2.3376, minorDiaMale: 2.2023, pitch: 0.25000 },
  { designation: '2-3/4-4',   tpi: 4,  majorDia: 2.7500, pitchDia: 2.5876, minorDiaMale: 2.4523, pitch: 0.25000 },
  { designation: '3-4',       tpi: 4,  majorDia: 3.0000, pitchDia: 2.8376, minorDiaMale: 2.7023, pitch: 0.25000 },
  { designation: '3-1/2-4',   tpi: 4,  majorDia: 3.5000, pitchDia: 3.3376, minorDiaMale: 3.2023, pitch: 0.25000 },
];

// Imperial UNF threads
export const unfThreads = [
  { designation: '#0-80',     tpi: 80, majorDia: 0.0600, pitchDia: 0.0519, minorDiaMale: 0.0451, pitch: 0.01250 },
  { designation: '#1-72',     tpi: 72, majorDia: 0.0730, pitchDia: 0.0640, minorDiaMale: 0.0565, pitch: 0.01389 },
  { designation: '#2-64',     tpi: 64, majorDia: 0.0860, pitchDia: 0.0759, minorDiaMale: 0.0674, pitch: 0.01563 },
  { designation: '#3-56',     tpi: 56, majorDia: 0.0990, pitchDia: 0.0874, minorDiaMale: 0.0778, pitch: 0.01786 },
  { designation: '#4-48',     tpi: 48, majorDia: 0.1120, pitchDia: 0.0985, minorDiaMale: 0.0871, pitch: 0.02083 },
  { designation: '#5-44',     tpi: 44, majorDia: 0.1250, pitchDia: 0.1102, minorDiaMale: 0.0979, pitch: 0.02273 },
  { designation: '#6-40',     tpi: 40, majorDia: 0.1380, pitchDia: 0.1218, minorDiaMale: 0.1082, pitch: 0.02500 },
  { designation: '#8-36',     tpi: 36, majorDia: 0.1640, pitchDia: 0.1460, minorDiaMale: 0.1309, pitch: 0.02778 },
  { designation: '#10-32',    tpi: 32, majorDia: 0.1900, pitchDia: 0.1697, minorDiaMale: 0.1527, pitch: 0.03125 },
  { designation: '#12-28',    tpi: 28, majorDia: 0.2160, pitchDia: 0.1928, minorDiaMale: 0.1734, pitch: 0.03571 },
  { designation: '1/4-28',    tpi: 28, majorDia: 0.2500, pitchDia: 0.2268, minorDiaMale: 0.2074, pitch: 0.03571 },
  { designation: '5/16-24',   tpi: 24, majorDia: 0.3125, pitchDia: 0.2854, minorDiaMale: 0.2629, pitch: 0.04167 },
  { designation: '3/8-24',    tpi: 24, majorDia: 0.3750, pitchDia: 0.3479, minorDiaMale: 0.3254, pitch: 0.04167 },
  { designation: '7/16-20',   tpi: 20, majorDia: 0.4375, pitchDia: 0.4050, minorDiaMale: 0.3780, pitch: 0.05000 },
  { designation: '1/2-20',    tpi: 20, majorDia: 0.5000, pitchDia: 0.4675, minorDiaMale: 0.4405, pitch: 0.05000 },
  { designation: '9/16-18',   tpi: 18, majorDia: 0.5625, pitchDia: 0.5264, minorDiaMale: 0.4964, pitch: 0.05556 },
  { designation: '5/8-18',    tpi: 18, majorDia: 0.6250, pitchDia: 0.5889, minorDiaMale: 0.5589, pitch: 0.05556 },
  { designation: '3/4-16',    tpi: 16, majorDia: 0.7500, pitchDia: 0.7094, minorDiaMale: 0.6755, pitch: 0.06250 },
  { designation: '7/8-14',    tpi: 14, majorDia: 0.8750, pitchDia: 0.8286, minorDiaMale: 0.7900, pitch: 0.07143 },
  { designation: '1-12',      tpi: 12, majorDia: 1.0000, pitchDia: 0.9459, minorDiaMale: 0.9008, pitch: 0.08333 },
  { designation: '1-1/8-12',  tpi: 12, majorDia: 1.1250, pitchDia: 1.0709, minorDiaMale: 1.0258, pitch: 0.08333 },
  { designation: '1-1/4-12',  tpi: 12, majorDia: 1.2500, pitchDia: 1.1959, minorDiaMale: 1.1508, pitch: 0.08333 },
  { designation: '1-3/8-12',  tpi: 12, majorDia: 1.3750, pitchDia: 1.3209, minorDiaMale: 1.2758, pitch: 0.08333 },
  { designation: '1-1/2-12',  tpi: 12, majorDia: 1.5000, pitchDia: 1.4459, minorDiaMale: 1.4008, pitch: 0.08333 },
];

// Metric threads (coarse pitch)
export const metricCoarseThreads = [
  { designation: 'M1',    pitch: 0.25,  majorDia: 1.000,  pitchDia: 0.838,  minorDiaMale: 0.693 },
  { designation: 'M1.2',  pitch: 0.25,  majorDia: 1.200,  pitchDia: 1.038,  minorDiaMale: 0.893 },
  { designation: 'M1.4',  pitch: 0.30,  majorDia: 1.400,  pitchDia: 1.205,  minorDiaMale: 1.032 },
  { designation: 'M1.6',  pitch: 0.35,  majorDia: 1.600,  pitchDia: 1.373,  minorDiaMale: 1.171 },
  { designation: 'M2',    pitch: 0.40,  majorDia: 2.000,  pitchDia: 1.740,  minorDiaMale: 1.509 },
  { designation: 'M2.5',  pitch: 0.45,  majorDia: 2.500,  pitchDia: 2.208,  minorDiaMale: 1.948 },
  { designation: 'M3',    pitch: 0.50,  majorDia: 3.000,  pitchDia: 2.675,  minorDiaMale: 2.387 },
  { designation: 'M3.5',  pitch: 0.60,  majorDia: 3.500,  pitchDia: 3.110,  minorDiaMale: 2.764 },
  { designation: 'M4',    pitch: 0.70,  majorDia: 4.000,  pitchDia: 3.545,  minorDiaMale: 3.141 },
  { designation: 'M5',    pitch: 0.80,  majorDia: 5.000,  pitchDia: 4.480,  minorDiaMale: 4.019 },
  { designation: 'M6',    pitch: 1.00,  majorDia: 6.000,  pitchDia: 5.350,  minorDiaMale: 4.773 },
  { designation: 'M7',    pitch: 1.00,  majorDia: 7.000,  pitchDia: 6.350,  minorDiaMale: 5.773 },
  { designation: 'M8',    pitch: 1.25,  majorDia: 8.000,  pitchDia: 7.188,  minorDiaMale: 6.466 },
  { designation: 'M10',   pitch: 1.50,  majorDia: 10.000, pitchDia: 9.026,  minorDiaMale: 8.160 },
  { designation: 'M12',   pitch: 1.75,  majorDia: 12.000, pitchDia: 10.863, minorDiaMale: 9.853 },
  { designation: 'M14',   pitch: 2.00,  majorDia: 14.000, pitchDia: 12.701, minorDiaMale: 11.546 },
  { designation: 'M16',   pitch: 2.00,  majorDia: 16.000, pitchDia: 14.701, minorDiaMale: 13.546 },
  { designation: 'M18',   pitch: 2.50,  majorDia: 18.000, pitchDia: 16.376, minorDiaMale: 14.933 },
  { designation: 'M20',   pitch: 2.50,  majorDia: 20.000, pitchDia: 18.376, minorDiaMale: 16.933 },
  { designation: 'M22',   pitch: 2.50,  majorDia: 22.000, pitchDia: 20.376, minorDiaMale: 18.933 },
  { designation: 'M24',   pitch: 3.00,  majorDia: 24.000, pitchDia: 22.051, minorDiaMale: 20.319 },
  { designation: 'M27',   pitch: 3.00,  majorDia: 27.000, pitchDia: 25.051, minorDiaMale: 23.319 },
  { designation: 'M30',   pitch: 3.50,  majorDia: 30.000, pitchDia: 27.727, minorDiaMale: 25.706 },
  { designation: 'M33',   pitch: 3.50,  majorDia: 33.000, pitchDia: 30.727, minorDiaMale: 28.706 },
  { designation: 'M36',   pitch: 4.00,  majorDia: 36.000, pitchDia: 33.402, minorDiaMale: 31.093 },
  { designation: 'M39',   pitch: 4.00,  majorDia: 39.000, pitchDia: 36.402, minorDiaMale: 34.093 },
  { designation: 'M42',   pitch: 4.50,  majorDia: 42.000, pitchDia: 39.077, minorDiaMale: 36.479 },
  { designation: 'M45',   pitch: 4.50,  majorDia: 45.000, pitchDia: 42.077, minorDiaMale: 39.479 },
  { designation: 'M48',   pitch: 5.00,  majorDia: 48.000, pitchDia: 44.752, minorDiaMale: 41.866 },
  { designation: 'M52',   pitch: 5.00,  majorDia: 52.000, pitchDia: 48.752, minorDiaMale: 45.866 },
  { designation: 'M56',   pitch: 5.50,  majorDia: 56.000, pitchDia: 52.428, minorDiaMale: 49.252 },
  { designation: 'M60',   pitch: 5.50,  majorDia: 60.000, pitchDia: 56.428, minorDiaMale: 53.252 },
  { designation: 'M64',   pitch: 6.00,  majorDia: 64.000, pitchDia: 60.103, minorDiaMale: 56.639 },
  { designation: 'M68',   pitch: 6.00,  majorDia: 68.000, pitchDia: 64.103, minorDiaMale: 60.639 },
  { designation: 'M72',   pitch: 6.00,  majorDia: 72.000, pitchDia: 68.103, minorDiaMale: 64.639 },
  { designation: 'M80',   pitch: 6.00,  majorDia: 80.000, pitchDia: 76.103, minorDiaMale: 72.639 },
  { designation: 'M90',   pitch: 6.00,  majorDia: 90.000, pitchDia: 86.103, minorDiaMale: 82.639 },
  { designation: 'M100',  pitch: 6.00,  majorDia: 100.000,pitchDia: 96.103, minorDiaMale: 92.639 },
];

// Metric fine threads (common sizes)
export const metricFineThreads = [
  { designation: 'M8x1',     pitch: 1.00,  majorDia: 8.000,  pitchDia: 7.350,  minorDiaMale: 6.773 },
  { designation: 'M8x0.75',  pitch: 0.75,  majorDia: 8.000,  pitchDia: 7.513,  minorDiaMale: 7.080 },
  { designation: 'M10x1.25', pitch: 1.25,  majorDia: 10.000, pitchDia: 9.188,  minorDiaMale: 8.466 },
  { designation: 'M10x1',    pitch: 1.00,  majorDia: 10.000, pitchDia: 9.350,  minorDiaMale: 8.773 },
  { designation: 'M10x0.75', pitch: 0.75,  majorDia: 10.000, pitchDia: 9.513,  minorDiaMale: 9.080 },
  { designation: 'M12x1.5',  pitch: 1.50,  majorDia: 12.000, pitchDia: 11.026, minorDiaMale: 10.160 },
  { designation: 'M12x1.25', pitch: 1.25,  majorDia: 12.000, pitchDia: 11.188, minorDiaMale: 10.466 },
  { designation: 'M12x1',    pitch: 1.00,  majorDia: 12.000, pitchDia: 11.350, minorDiaMale: 10.773 },
  { designation: 'M14x1.5',  pitch: 1.50,  majorDia: 14.000, pitchDia: 13.026, minorDiaMale: 12.160 },
  { designation: 'M14x1',    pitch: 1.00,  majorDia: 14.000, pitchDia: 13.350, minorDiaMale: 12.773 },
  { designation: 'M16x1.5',  pitch: 1.50,  majorDia: 16.000, pitchDia: 15.026, minorDiaMale: 14.160 },
  { designation: 'M16x1',    pitch: 1.00,  majorDia: 16.000, pitchDia: 15.350, minorDiaMale: 14.773 },
  { designation: 'M18x2',    pitch: 2.00,  majorDia: 18.000, pitchDia: 16.701, minorDiaMale: 15.546 },
  { designation: 'M18x1.5',  pitch: 1.50,  majorDia: 18.000, pitchDia: 17.026, minorDiaMale: 16.160 },
  { designation: 'M20x2',    pitch: 2.00,  majorDia: 20.000, pitchDia: 18.701, minorDiaMale: 17.546 },
  { designation: 'M20x1.5',  pitch: 1.50,  majorDia: 20.000, pitchDia: 19.026, minorDiaMale: 18.160 },
  { designation: 'M22x2',    pitch: 2.00,  majorDia: 22.000, pitchDia: 20.701, minorDiaMale: 19.546 },
  { designation: 'M22x1.5',  pitch: 1.50,  majorDia: 22.000, pitchDia: 21.026, minorDiaMale: 20.160 },
  { designation: 'M24x2',    pitch: 2.00,  majorDia: 24.000, pitchDia: 22.701, minorDiaMale: 21.546 },
  { designation: 'M24x1.5',  pitch: 1.50,  majorDia: 24.000, pitchDia: 23.026, minorDiaMale: 22.160 },
  { designation: 'M27x2',    pitch: 2.00,  majorDia: 27.000, pitchDia: 25.701, minorDiaMale: 24.546 },
  { designation: 'M30x2',    pitch: 2.00,  majorDia: 30.000, pitchDia: 28.701, minorDiaMale: 27.546 },
  { designation: 'M33x2',    pitch: 2.00,  majorDia: 33.000, pitchDia: 31.701, minorDiaMale: 30.546 },
  { designation: 'M36x3',    pitch: 3.00,  majorDia: 36.000, pitchDia: 34.051, minorDiaMale: 32.319 },
  { designation: 'M36x2',    pitch: 2.00,  majorDia: 36.000, pitchDia: 34.701, minorDiaMale: 33.546 },
];

// Calculate thread depth from pitch (60-degree thread form)
// Single depth = 0.6134 * pitch (for V-threads, Unified/ISO)
export const calculateThreadDepth = (pitch, isMetric = false) => {
  const singleDepth = 0.6134 * pitch;
  return {
    singleDepth: parseFloat(singleDepth.toFixed(5)),
    doubleDepth: parseFloat((singleDepth * 2).toFixed(5)),
  };
};

// Generate long-hand threading passes (constant infeed or compound angle)
export const calculateThreadingPasses = (totalDepth, method = 'compound') => {
  // Industry standard: first pass is largest, decreasing by sqrt method
  // Total depth divided into passes where each pass removes equal AREA (not depth)
  const passes = [];
  const numPasses = Math.max(4, Math.ceil(totalDepth / 0.005)); // Minimum 4 passes
  
  for (let i = 1; i <= numPasses; i++) {
    // Square root method: depth_n = totalDepth * sqrt(n/N)
    const cumulativeDepth = totalDepth * Math.sqrt(i / numPasses);
    const doc = i === 1 ? cumulativeDepth : cumulativeDepth - (totalDepth * Math.sqrt((i - 1) / numPasses));
    
    passes.push({
      passNum: i,
      cumulativeDepth: parseFloat(cumulativeDepth.toFixed(5)),
      depthOfCut: parseFloat(doc.toFixed(5)),
      // For compound angle (29.5 deg), X moves are adjusted
      xPosition: method === 'compound' 
        ? parseFloat((cumulativeDepth * Math.cos(29.5 * Math.PI / 180)).toFixed(5))
        : parseFloat(cumulativeDepth.toFixed(5)),
    });
  }
  
  return passes;
};

// Get all threads for a given system type
export const getThreadList = (system, series) => {
  if (system === 'imperial') {
    if (series === 'UNC') return uncThreads;
    if (series === 'UNF') return unfThreads;
  }
  if (system === 'metric') {
    if (series === 'coarse') return metricCoarseThreads;
    if (series === 'fine') return metricFineThreads;
  }
  return [];
};

// Look up a specific thread by designation
export const findThread = (designation) => {
  const allThreads = [...uncThreads, ...unfThreads, ...metricCoarseThreads, ...metricFineThreads];
  return allThreads.find(t => t.designation === designation);
};
